<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We use a single essential cookie to store a JSON Web Token (JWT), which:</p>
    <ul class="list-disc list-inside">
      <li>Authenticates your login session.</li>
      <li>Allows secure access to your account.</li>
      <li>Expires automatically or when you log out.</li>
    </ul>
    <p>Additionally, we use local storage for your site configuration preferences:</p>
    <ul class="list-disc list-inside">
      <li>Saves theme, layout, and other user-specific settings.</li>
      <li>Stored only on your device and never transmitted to our servers.</li>
    </ul>
    <p>Because the cookie is essential for login, separate cookie consent banners are not required under GDPR.</p>
  </div>
</template>